import createCache from '@emotion/cache';
import type { EmotionCache } from '@emotion/cache';

/**
 * Cache de emotion compartido entre server y cliente.
 *
 * MUI genera CSS-in-JS: sin extraer ese CSS en el server, el primer paint llega sin
 * estilos (flash) y el HTML que ve el crawler no refleja el layout. El server crea un
 * cache por request, extrae el CSS crítico (`@emotion/server`) y lo inyecta en el
 * `<head>`; el cliente usa la **misma key** para poder reusar esos estilos al hidratar.
 */
export const EMOTION_CACHE_KEY = 'ap';

export function createEmotionCache(): EmotionCache {
  return createCache({ key: EMOTION_CACHE_KEY, prepend: true });
}
